<template>
  <div class="container">
    <custom-select
      label="Ocupación"
      :value="value"
      name="ocupacion"
      @input="onChange"
      :items="ocupaciones"
      :quantumObfuscate="quantumObfuscate"
    />
  </div>
</template>

<script>
import { ocupaciones as _ocupaciones } from "@/config/constants";
import CustomSelect from "@/components/core/custom/CustomSelect";
import find from "lodash/find";
import get from "lodash/get";

export default {
  name: "JobOccupation",
  components: { CustomSelect },
  props: {
    value: String,
    situacionLaboral: String,
    quantumObfuscate: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      ocupaciones: []
    };
  },
  watch: {
    situacionLaboral: function(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getOcupaciones(newVal);
      }
    }
  },
  mounted() {
    if (this.situacionLaboral) {
      this.getOcupaciones(this.situacionLaboral);
    }
  },
  methods: {
    getOcupaciones(situacionLaboral) {
      this.ocupaciones = [];
      // Tengo que filtrarlas por Situacion situacionLaboral
      _ocupaciones.forEach(val => {
        if (val.situacionLaboral.indexOf(situacionLaboral) >= 0) {
          this.ocupaciones.push(val);
        }
      });
      let defaultValue = get(
        find(this.ocupaciones, { value: this.value }),
        "value",
        this.ocupaciones[0].value
      );
      this.$emit("input", defaultValue);
    },
    onChange(val) {
      this.$emit("input", val);
    }
  }
};
</script>
